module.exports = __webpack_public_path__ + "img/moke.426a488b.svg";